<script setup lang="ts">
import { cn } from '@/lib/utils'
import { SelectScrollDownButton, type SelectScrollDownButtonProps } from 'radix-vue'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<SelectScrollDownButtonProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <SelectScrollDownButton
    v-bind="delegatedProps"
    :class="cn('flex cursor-default items-center justify-center py-1', props.class)"
  >
    <slot>
      <Icon name="lucide:chevron-down" class="size-4" />
    </slot>
  </SelectScrollDownButton>
</template>
